import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const MapPage = lazy(() => import('../pages/map/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/map',
    element: <MapPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;